// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"888":"98e2d21d","1612":"96a8f119"}[chunkId] || chunkId) + "." + {"888":"c932ed74f5ba70d6","1157":"f8fae7796f9e1ab6","1612":"6504ec4d39995613","2166":"83c09250e0c570aa","2466":"a21cd715456f2258","2642":"bf26e940cada558f","6521":"2d5ffa89d7a781e2","7284":"c25a566ee786eec1"}[chunkId] + ".js";
};